import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import unitysceen from "../assests/images/unitysceen.png";
import upload from "../assests/images/upload.png";
import uploadUnity from "../assests/images/uploadUnity.png";
import app from "../Firebase";
import Sidebar from "./Sidebar";
import Constant from "../Components/Utils/Constant";
import { Link, useLocation } from "react-router-dom";
import { IoIosSearch } from "react-icons/io";
import EditCategoryForm from "./EditCategoryForm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contextProvider } from "../Components/Context";
import { RiArrowDownSFill } from "react-icons/ri";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function Unitymodals({ video }) {
  const MASTER_CATEGORY_LIST = [];
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [platform, setPlatform] = useState("");
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [emailFilter, setEmailFilter] = useState("All");
  const [categoryFilter, setCategoryFilter] = useState("All");

  const categoryDropdownRef = useRef(null);
  const companyDropdownRef = useRef(null);
  const assignDropdownRef = useRef(null);

  const [showPopup, setShowPopup] = useState(false);
  const handleShowPopup = () => setShowPopup(true);
  const handleClosePopup = () => setShowPopup(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [companyname, setCompanyname] = useState("");
  const [category, setCategory] = useState("");
  const [which_type, setWhich_type] = useState("");
  const [access, setAccess] = useState([]);
  const [modelname, setModelname] = useState("");
  const [thumbnail, setThumbnail] = useState(undefined);
  const [model, setModel] = useState(undefined);
  const [thumbnailPerc, setThumbnailPerc] = useState(0);
  const [modelPerc, setModelPerc] = useState(0);
  const [isUnitySceneUploading, setIsUnitySceneUploading] = useState(false);
  const [unitySceneUploadProgress, setUnitySceneUploadProgress] = useState(0);
  const [inputs, setInputs] = useState({});
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [user, setUser] = useState([]);
  const [totalCount1, setTotalCount1] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const { totalCount, setTotalCount } = useContext(contextProvider);
  const [searchUserTerm, setSearchUserTerm] = useState("");
  const [filterUserData, setFilterUserData] = useState([]);
  const [searchCompanyTerm, setSearchCompanyTerm] = useState("");
  const [filterCompanyData, setFilterCompanyData] = useState([]);
  const [searchCategoryTerm, setSearchCategoryTerm] = useState("");
  const [filterCategoryData, setFilterCategoryData] = useState([]);
  const [userName, setUserName] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customCategory, setCustomCategory] = useState("");
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [customCompanyname, setCustomCompanyname] = useState("");
  const [uniqueCompanynames, setUniqueCompanynames] = useState([]);
  const [dropdownOpenCompany, setDropdownOpenCompany] = useState(false);
  const [selectedItemCompany, setSelectedItemCompany] = useState(null);
  const [editPopup, setEditPopup] = useState(false);
  const [modelmanager, setModelmanager] = useState([]);
  const highlightedId = useSelector((state) => state.DataReducer.highlightedId);
  const [currentPage, setCurrentPage] = useState(1);
  const query = useQuery();
  const initialType = query.get("type") || "2D";
  const initialPlatform = query.get("platform") || "All";

  const [modelType, setModelType] = useState(initialType);
  const [platformFilter, setPlatformFilter] = useState(initialPlatform);

  const handleModelTypeChange = (event) => {
    const selectedType = event.target.value;
    setWhich_type(selectedType);
  };

  useEffect(() => {
    const storedName = localStorage.getItem("name");

    if (storedName) {
      setUserName(storedName);
    } else {
      setUserName("Unauthorized");
    }
    const fetchUser = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/user/get`);
        const data = await response.json();
        if (data && data.admins) {
          setUser(data.admins);
          if (data.success) {
            setTotalCount1(data.totalCount);
          }
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (
        companyDropdownRef.current &&
        !companyDropdownRef.current.contains(event.target)
      ) {
        setDropdownOpenCompany(false);
      }
      if (
        assignDropdownRef.current &&
        !assignDropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpenfilter(false);
      }
    }
    if (dropdownOpen || dropdownOpenCompany || isDropdownOpenfilter) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen, dropdownOpenCompany, isDropdownOpenfilter]);

  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleEditCategory = () => {};
  const handleCloseEdit = () => {};

  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
    setDropdownOpen(null);
    setDropdownOpenCompany(null);
  };

  // ✅ SOLUTION: `access` array is now the single source of truth. `checkboxStates` is removed.
  const selectAllChecked = useMemo(() => user.length > 0 && access.length === user.length, [access, user]);
  
  // ✅ SOLUTION: Reworked handler accepts email, toggles it in `access` state, and clears search.
  const handleCheckboxChanged = (email) => {
    setAccess((prevAccess) => {
      if (prevAccess.includes(email)) {
        return prevAccess.filter((item) => item !== email);
      } else {
        return [...prevAccess, email];
      }
    });
    setSearchUserTerm("");
    setFilterUserData([]);
  };

  // ✅ SOLUTION: Reworked "Select All" handler directly manipulates the `access` state.
  const handleSelectAllChanged = () => {
    if (selectAllChecked) {
      setAccess([]);
    } else {
      const allUserEmails = user.map((item) => item.email);
      setAccess(allUserEmails);
    }
  };

  // <<< YEH LOGIC UPLOAD FORM KE CATEGORY DROPDOWN KO POPULATE KARTA HAI >>>
  // Yeh `videos` state se ek unique, sorted, aur non-empty category list banata hai.
  // useEffect(() => {
  //   if (videos && videos.length > 0) {
  //     const allCategories = videos.map((item) => item.category).filter(Boolean);
  //     const uniqueCategoryStrings = Array.from(new Set(allCategories));
  //     uniqueCategoryStrings.sort();
  //     const uniqueCategoriesList = uniqueCategoryStrings.map(
  //       (category, index) => ({
  //         id: index,
  //         category: category,
  //       })
  //     );
  //     setUniqueCategories(uniqueCategoriesList);
  //   }
  // }, [videos]);


  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
    setIsDropdownOpenfilter(null);
    setDropdownOpenCompany(null);
    setFilterCategoryData([]);
  };

  const handleCategorySelect = (item) => {
    setSelectedItem(item);
    setCategory(item.category);
    setDropdownOpen(false);
  };

  const handleCustomCategoryAdd = () => {
    if (customCategory.trim() !== "") {
      const newCategory = {
        id: uniqueCategories.length,
        category: customCategory.trim(),
      };
      setUniqueCategories([...uniqueCategories, newCategory]);
      setSelectedItem(newCategory);
      setCategory(customCategory.trim());
      setDropdownOpen(false);
      setCustomCategory("");
    }
  };

  const handleCustomCategoryChange = (e) => {
    setCustomCategory(e.target.value);
  };

  // useEffect(() => {
  //   if (videos && videos.length > 0) {
  //     const uniqueCompanyNames = Array.from(
  //       new Set(videos.map((item) => item.companyname))
  //     );
  //     const uniqueCompanynameList = uniqueCompanyNames.map(
  //       (companyname, index) => ({
  //         id: index,
  //         companyname: companyname,
  //       })
  //     );
  //     setUniqueCompanynames(uniqueCompanynameList);
  //   }
  // }, [videos]);

  const handleDropdownToggleCompanyname = () => {
    setDropdownOpenCompany(!dropdownOpenCompany);
    setDropdownOpen(null);
    setIsDropdownOpenfilter(null);
    setSearchCompanyTerm("");
    setFilterCompanyData([]);
  };

  const handleCompanyNameSelect = (item) => {
    setSelectedItemCompany(item);
    setCompanyname(item.companyname);
    setDropdownOpenCompany(false);
    setSearchCompanyTerm("");
  };

  const handleCustomCompanynameAdd = () => {
    if (customCompanyname.trim() !== "") {
      const newCompanyname = {
        id: uniqueCompanynames.length,
        companyname: customCompanyname.trim(),
      };
      setUniqueCompanynames([...uniqueCompanynames, newCompanyname]);
      setSelectedItemCompany(newCompanyname);
      setCompanyname(customCompanyname.trim());
      setDropdownOpenCompany(false);
      setSearchCompanyTerm("");
      setCustomCompanyname("");
    }
  };

  const handleCustomCompanynameChange = (e) => {
    setCustomCompanyname(e.target.value);
  };

  const fetchVideos = async (page) => {
    try {
      const response = await fetch(
        `${Constant.BASE_URL}/model/get?page=${page}`
      );
      const data = await response.json();
      const videosArray = data.videos || data;
      setVideos(Array.isArray(videosArray) ? videosArray : []);
      setTotalCount(
        data.totalCount || (Array.isArray(videosArray) ? videosArray.length : 0)
      );
      setTotalPages(data.totalPages || 1);
      setCurrentPage(page);
    } catch (error) {
      console.error("Error fetching videos:", error);
      setVideos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVideos(currentPage);
  }, [currentPage, showPopup, editPopup]);

  const handlePageClick = async ({ selected }) => {
    const newPageNumber = selected + 1;
    setCurrentPage(newPageNumber);
  };

  useEffect(() => {
    if (model) {
      uploadFile(model, "modelUrl");
    }
  }, [model]);

  useEffect(() => {
    if (thumbnail) {
      uploadFile(thumbnail, "thumbnailUrl");
    }
  }, [thumbnail]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size <= 200 * 1024) {
        setThumbnail(file);
        setModelname(file.name);
        setSelectedImage(URL.createObjectURL(file));
      } else {
        toast.error("Please select an image below 200 KB.");
      }
    }
  };

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    let folder;
    if (fileType === "thumbnailUrl") {
      folder = "thumbnail/";
    } else if (fileType === "modelUrl") {
      folder = "model/";
    } else if (fileType === "unitySceneUrl") {
      folder = "unityScene/";
    } else {
      return;
    }
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (fileType === "thumbnailUrl") {
          setThumbnailPerc(Math.round(progress));
        } else if (fileType === "modelUrl") {
          setModelPerc(Math.round(progress));
        } else if (fileType === "unitySceneUrl") {
          setUnitySceneUploadProgress(Math.round(progress));
        }
      },
      (error) => {
        console.log(error);
        toast.error(`Failed to upload ${fileType}`);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setInputs((prev) => ({
            ...prev,
            [fileType]: downloadURL,
          }));
        });
      }
    );
  };

  const handleClear = () => {
    if (selectedImage !== null) {
      setSelectedImage(null);
    }
    if (model !== null) {
      setModel(null);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (!platform) {
  //       toast.error("Please select a platform");
  //       return;
  //     }
  //     if (!model) {
  //       toast.error("Please select a model file");
  //       return;
  //     }
  //     const response = await axios.post(`${Constant.BASE_URL}/model/upload`, {
  //       companyname,
  //       modelname: model.name,
  //       category,
  //       which_type,
  //       access,
  //       createdby: userName,
  //       model: inputs.modelUrl,
  //       thumbnail: inputs.thumbnailUrl,
  //       platform,
  //     });

  //     if (response.status === 201) {
  //       handleClosePopup();
  //       setCompanyname("");
  //       setModelname("");
  //       setCategory("");
  //       setWhich_type("");
  //       setAccess([]);
  //       setThumbnail(undefined);
  //       setModel(undefined);
  //       setIsUnitySceneUploading(false);
  //       setUnitySceneUploadProgress(0);
  //       setThumbnailPerc(0);
  //       setModelPerc(0);
  //       setSelectedImage(null);
  //       setPlatform("");
  //       toast.success("Unity Model Created Successfully!");
  //     } else {
  //       toast.error("Failed to create Unity Model");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("An error occurred while creating the model.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Get the token from localStorage
    const token = localStorage.getItem("token"); 

    // 2. Check if the token exists before proceeding
    if (!token) {
      toast.error("Authentication token not found. Please log in again.");
      return;
    }

    try {
      if (!platform) {
        toast.error("Please select a platform");
        return;
      }
      if (!model) {
        toast.error("Please select a model file");
        return;
      }

      // 3. Add the token to the request headers
      const response = await axios.post(
        `${Constant.BASE_URL}/model/upload-new`,
        {
          companyname,
          modelname: model.name,
          category,
          which_type,
          access,
          createdby: userName,
          model: inputs.modelUrl,
          thumbnail: inputs.thumbnailUrl,
          platform,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Standard format for Bearer tokens
          },
        }
      );

      if (response.status === 201) {
        handleClosePopup();
        setCompanyname("");
        setModelname("");
        setCategory("");
        setWhich_type("");
        setAccess([]);
        setThumbnail(undefined);
        setModel(undefined);
        setIsUnitySceneUploading(false);
        setUnitySceneUploadProgress(0);
        setThumbnailPerc(0);
        setModelPerc(0);
        setSelectedImage(null);
        setPlatform("");
        toast.success("Unity Model Created Successfully!");
      } else {
        toast.error("Failed to create Unity Model");
      }
    } catch (error) {
      console.log(error);
      // Check for specific backend authentication errors
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        toast.error("Session expired or invalid. Please log in again.");
      } else {
        toast.error("An error occurred while creating the model.");
      }
    }
  };
  const style = {
    width: `${unitySceneUploadProgress}%`,
    transition: "width 0.1s ease-in-out",
  };
  const style1 = {
    width: `${thumbnailPerc}%`,
    transition: "width 0.1s ease-in-out",
  };

  useEffect(() => {
    return () => {
      setPlatform("");
      setPlatformDropdownOpen(false);
    };
  }, []);

  const handleUserSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchUserTerm(searchTerm);
    const filteredData = user.filter((item) =>
      item.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilterUserData(filteredData);
  };

  const handleCategorySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCategoryTerm(searchTerm);
    const filteredCategories = uniqueCategories.filter((item) =>
      item.category.toLowerCase().includes(searchTerm)
    );
    setFilterCategoryData(filteredCategories);
  };

  const handleCompanySearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchCompanyTerm(searchTerm);
    const filteredCompanyname = uniqueCompanynames.filter((item) =>
      item.companyname.toLowerCase().includes(searchTerm)
    );
    setFilterCompanyData(filteredCompanyname);
  };

  useEffect(() => {
    const fetchModelmanager = async () => {
      try {
        const response = await fetch(`${Constant.BASE_URL}/modelmanager/get`);
        const data = await response.json();
        if (data && data.modelmanager) {
          setModelmanager(data.modelmanager);
        }
      } catch (error) {
        console.error("Error fetching model managers:", error);
      }
    };
    fetchModelmanager();
  }, []);
  
  // const assignedUsers = useMemo(() => {
  //   if (!videos || videos.length === 0) {
  //     return [];
  //   }
  //   const allAssignedEmails = videos.flatMap((video) => video.access || []);
  //   const uniqueEmails = [...new Set(allAssignedEmails)];
  //   return uniqueEmails.sort();
  // }, [videos]);

  // // <<< YEH LOGIC CATEGORY FILTER DROPDOWN KO POPULATE KARTA HAI >>>
  // // Yeh `videos` state se ek unique, sorted, aur non-empty category list banata hai.
  // const assignedCategories = useMemo(() => {
  //   if (!videos || videos.length === 0) {
  //     return [];
  //   }
  //   const allCategories = videos.map((video) => video.category).filter(Boolean);
  //   const uniqueCategories = [...new Set(allCategories)];
  //   return uniqueCategories.sort();
  // }, [videos]);

const { assignedUsers, allPossibleCategories, allPossibleCompanies } = useMemo(() => {
  if (!videos) {
    return { assignedUsers: [], allPossibleCategories: MASTER_CATEGORY_LIST, allPossibleCompanies: [] };
  }

  const emails = videos.flatMap((video) => video.access || []);
  const uniqueEmails = [...new Set(emails)].sort();

  const catsFromModels = videos.map((video) => video.category).filter(Boolean);
  const uniqueCats = [...new Set([...MASTER_CATEGORY_LIST, ...catsFromModels])].sort();
  
  const compsFromModels = videos.map((video) => video.companyname).filter(Boolean);
  const uniqueComps = [...new Set(compsFromModels)].sort();

  return { 
    assignedUsers: uniqueEmails, 
    allPossibleCategories: uniqueCats,
    allPossibleCompanies: uniqueComps
  };
}, [videos]);

// This useEffect now just syncs the upload form's state
useEffect(() => {
  setUniqueCategories(
    allPossibleCategories.map((cat, i) => ({ id: i, category: cat }))
  );
  setUniqueCompanynames(
    allPossibleCompanies.map((name, i) => ({ id: i, companyname: name }))
  );
}, [allPossibleCategories, allPossibleCompanies]);
  const filteredVideos = (videos || []).filter((video) => {
    const typeMatch = modelType === "All" || video.which_type === modelType;
    const platformMatch =
      platformFilter === "All" || video.platform === platformFilter;
    const emailMatch =
      emailFilter === "All" ||
      (video.access && video.access.includes(emailFilter));
    const categoryMatch = categoryFilter === "All" || video.category === categoryFilter;
    return typeMatch && platformMatch && emailMatch && categoryMatch;
  });

  const filteredCount = filteredVideos.length;

  return (
    <Sidebar>
      <>
        <ToastContainer />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            className="bg-white h-[78.55vh]"
            style={{ borderRadius: "0px 0px 11px 11px" }}
          >
            <div className="flex justify-between px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex items-center">
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #ffffff 0%, #f1f1f1 100%)",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                  }}
                  className="flex flex-wrap items-center justify-center gap-4 px-2 py-1 mx-5 border border-white rounded-md"
                >
                  <select
                    value={modelType}
                    onChange={(e) => setModelType(e.target.value)}
                    className="bg-white text-gray-700 border border-gray-300 rounded-md px-3 outline-none cursor-pointer"
                  >
                    <option value="2D">2D Models</option>
                    <option value="3D">3D Models</option>
                  </select>
                </div>

                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #ffffff 0%, #f1f1f1 100%)",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                  }}
                  className="flex flex-wrap items-center justify-center gap-4 px-2 py-1 mx-5 border border-white rounded-md"
                >
                  <select
                    value={platformFilter}
                    onChange={(e) => setPlatformFilter(e.target.value)}
                    className="bg-white text-gray-700 border border-gray-300 rounded-md px-3 outline-none cursor-pointer"
                  >
                    <option value="All">All Platforms</option>
                    <option value="iOS">iOS</option>
                    <option value="Android">Android</option>
                  </select>
                </div>

                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #ffffff 0%, #f1f1f1 100%)",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                  }}
                  className="flex flex-wrap items-center justify-center gap-4 px-2 py-1 mx-5 border border-white rounded-md"
                >
                  <select
                    value={emailFilter}
                    onChange={(e) => setEmailFilter(e.target.value)}
                    className="bg-white text-gray-700 border border-gray-300 rounded-md px-3 outline-none cursor-pointer max-h-28"
                  >
                    <option value="All">All Users</option>
                    {assignedUsers.map((email, idx) => (
                      <option key={idx} value={email}>
                        {email}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div
                    style={{
                      background:
                        "radial-gradient(125% 125% at 85.42% 0%, #ffffff 0%, #f1f1f1 100%)",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                    }}
                    className="flex flex-wrap items-center justify-center gap-4 px-2 py-1 mx-5 border border-white rounded-md"
                  >
                    <select
                      value={categoryFilter}
                      onChange={(e) => setCategoryFilter(e.target.value)}
                      className="bg-white text-gray-700 border border-gray-300 rounded-md px-3 outline-none cursor-pointer max-h-28"
                    >
                      <option value="All">All Categories</option>
                      {/* ✅ Now uses the complete master list */}
                      {allPossibleCategories.map((cat, idx) => (
                        <option key={idx} value={cat}>
                          {cat}
                        </option>
                      ))}
                    </select>
                  </div>
              </div>
              <div className="flex ">
                <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                  onClick={handleShowPopup}
                  className="px-2 py-2 xl:p-1 flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-5 xl:w-fit lg:w-fit"
                >
                  <div className="cursor-pointer text-4lg 2xl:text-4xl">
                    <p>Upload Model</p>
                  </div>
                </div>
              </div>
            </div>
            <hr className="w-full border border-gray-300 " />
            <div className="flex flex-wrap items-center justify-center w-full px-12 py-6 lg:px-5 2xl:px-16">
              <div className="grid grid-cols-6 text-wrap items-start gap-20 w-full lg:gap-15 xl:gap-20 2xl:gap-30 overflow-y-auto lg:h-[65vh] xl:h-[61vh] 2xl:h-[66vh] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 unitymodel">
                {[...filteredVideos]
                  .sort((a, b) => a.modelname.localeCompare(b.modelname))
                  .map((video) => (
                    <div
                      key={video._id}
                      className="max-w-[150px] flex flex-col items-center text-wrap overflow-wrap cursor-pointer"
                      style={{
                        background:
                          highlightedId === video._id ? "yellow" : "none",
                      }}
                    >
                      <img
                        onClick={() => {
                          setEditPopup(video);
                        }}
                        src={video?.thumbnail}
                        alt={video?.modelname}
                        className="w-[120px] h-[100px] pl-5 object-contain"
                      />
                      <p
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-all",
                        }}
                        className="text-center"
                      >
                        {video?.modelname}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {editPopup && (
            <EditCategoryForm
              editPopup={editPopup}
              setEditPopup={setEditPopup}
            />
          )}

          {showPopup && (
            <div className="popup-formmodel">
              <div className="flex flex-col items-center justify-center px-10 py-6 bg-white rounded-md w-fit h-fit">
                <h1 className="text-lg font-semibold"> Upload Model</h1>
                <div className="h-[2px] w-full bg-[#959595] mt-2" />
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-row items-center justify-between gap-16 px-4 mt-5">
                    <div className="flex flex-col items-center gap-6">
                      <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                        <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                          <div className="pt-2 text-xs font-bold">
                            Thumbnail :
                          </div>
                          <div className="h-[1px] min-w-full bg-[#959595a0]" />
                        </div>

                        <div className="flex items-center mx-2 justify-center h-[110px]">
                          <label
                            htmlFor="thumbnail"
                            className="cursor-pointer"
                          >
                            {selectedImage ? (
                              <img
                                alt="upload"
                                src={selectedImage}
                                className="w-32 h-24 object-contain"
                              />
                            ) : (
                              <img
                                alt="upload"
                                src={upload}
                                className="w-12 h-8"
                              />
                            )}
                          </label>
                          <input
                            id="thumbnail"
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={handleImageChange}
                            required
                          />
                        </div>

                        <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                          <div className="h-[2px] min-w-full bg-[#959595a0]" />
                          <div className="text-center text-[#959595a0] text-xs">
                            {thumbnail
                              ? thumbnail.name.length > 20
                                ? thumbnail.name.slice(0, 19) + "..."
                                : thumbnail.name
                              : "Upload Thumbnail"}
                          </div>
                        </div>
                        {thumbnailPerc > 0 && (
                          <div className="w-full h-2">
                            <div
                              className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                              style={style1}
                            ></div>
                          </div>
                        )}
                      </div>
                      <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                        <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                          <div className="pt-2 text-xs font-bold">
                            Upload Model File :
                          </div>
                          <div className="h-[1px] min-w-full bg-[#959595a0]" />
                        </div>
                        <div className="flex mx-2 items-center justify-center h-[110px]">
                          <label htmlFor="model" className="cursor-pointer">
                            {model ? (
                              <img
                                alt="upload"
                                src={unitysceen}
                                className="w-16 h-16"
                              />
                            ) : (
                              <img
                                alt="upload"
                                src={uploadUnity}
                                className="w-16 h-16"
                              />
                            )}
                          </label>
                          <input
                            className="hidden"
                            id="model"
                            type="file"
                            required
                            onChange={(e) => {
                              setIsUnitySceneUploading(true);
                              setUnitySceneUploadProgress(0);
                              setModel(e.target.files[0]);
                              uploadFile(e.target.files[0], "modelUrl");
                            }}
                          />
                        </div>

                        <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                          <div className="h-[2px] min-w-full bg-[#959595a0]" />
                          <div className="text-center text-[#959595a0] text-xs">
                            {model
                              ? model.name.length > 20
                                ? model.name.slice(0, 19) + "..."
                                : model.name
                              : "No file selected"}
                          </div>
                        </div>
                        {modelPerc > 0 && (
                          <div className="w-full h-2">
                            <div
                              className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257] transition-width duration-100 ease-in-out"
                              style={{ width: `${modelPerc}%` }}
                            ></div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-col items-start gap-4">
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model name :
                        </label>
                        <input
                          disabled
                          value={model ? model.name : "No file selected..."}
                          type="text"
                          id="yourInput"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="Super Admin (Auto)"
                        />
                      </div>
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="modelTypeSelect"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model Type:
                          <span className="ml-1 text-red-500">*</span>
                        </label>
                        <select
                          id="modelTypeSelect"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          value={which_type}
                          onChange={handleModelTypeChange}
                          required
                        >
                          <option value="">Select Model Type</option>{" "}
                          <option value="2D">2D</option>
                          <option value="3D">3D</option>
                        </select>
                      </div>
                      <div
                        ref={categoryDropdownRef}
                        className="relative flex items-center justify-start py-3 cursor-pointer"
                      >
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Category :<span className="ml-1 text-red-500">*</span>
                        </label>
                        <div className="flex pb-1 border-b border-gray-500 outline-none ">
                          <input
                            type="text"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            placeholder="Select category"
                            style={{
                              border: "none",
                              outline: "none",
                              textAlign: "center",
                            }}
                            required
                            disabled
                          />
                          <RiArrowDownSFill
                            onClick={handleDropdownToggle}
                            className="text-xl"
                          />
                          {dropdownOpen && (
                            <div
                              style={{
                                border: "1px solid #0000000a",
                                zIndex: "100",
                              }}
                              className="lg:text-[10px] lg:w-fit xl:text-[15px] py-1 absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[350px] modelscroll"
                            >
                              <div className=" flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black  bg-white shadow-md border border-black-300 border-opacity-60">
                                <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                <input
                                  type="text"
                                  placeholder="Search..."
                                  onChange={handleCategorySearch}
                                  className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                />
                              </div>
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px]  bg-white shadow-md">
                                <input
                                  type="text"
                                  value={customCategory}
                                  onChange={handleCustomCategoryChange}
                                  placeholder="Add custom category"
                                  style={{ border: "none", outline: "none" }}
                                />
                                <button
                                  type="button"
                                  className="px-2"
                                  onClick={handleCustomCategoryAdd}
                                >
                                  <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]">
                                    {" "}
                                    Add
                                  </span>
                                </button>
                              </div>
                              {filterCategoryData?.length > 0
                                ? filterCategoryData.map((item, index) => (
                                    <div
                                      key={item.id}
                                      className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                      onClick={() => handleCategorySelect(item)}
                                    >
                                      {item.category}
                                    </div>
                                  ))
                                : uniqueCategories.map((item) => (
                                    <div
                                      key={item.id}
                                      className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                      onClick={() => handleCategorySelect(item)}
                                    >
                                      {item.category}
                                    </div>
                                  ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        ref={companyDropdownRef}
                        className="relative flex items-center justify-start py-3 cursor-pointer"
                      >
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Company Name :
                        </label>
                        <div className="flex pb-1 border-b border-gray-500 outline-none">
                          <input
                            type="text"
                            value={companyname}
                            onChange={(e) => setCompanyname(e.target.value)}
                            placeholder="Select company"
                            style={{
                              border: "none",
                              outline: "none",
                              textAlign: "center",
                            }}
                            disabled
                          />
                          <RiArrowDownSFill
                            onClick={handleDropdownToggleCompanyname}
                            className="text-xl"
                          />
                          {dropdownOpenCompany && (
                            <div
                              style={{
                                border: "1px solid #0000000a",
                                zIndex: "100",
                              }}
                              className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-25 bg-white shadow-xl rounded-md overflow-y-auto h-[280px] modelscroll"
                            >
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                                <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                <input
                                  type="text"
                                  placeholder="Search..."
                                  onChange={handleCompanySearch}
                                  className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                />
                              </div>
                              <div className="flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md">
                                <input
                                  type="text"
                                  value={customCompanyname}
                                  onChange={handleCustomCompanynameChange}
                                  placeholder="Add custom company"
                                  style={{ border: "none", outline: "none" }}
                                />
                                <button
                                  type="button"
                                  className="px-2"
                                  onClick={handleCustomCompanynameAdd}
                                >
                                  <span className="px-1 border border-grey-200 rounded-sm text-grey-500 text-[10px]">
                                    {" "}
                                    Add
                                  </span>
                                </button>
                              </div>
                              <div className="overflow-y-auto h-[170px] modelscroll">
                                {filterCompanyData?.length > 0
                                  ? filterCompanyData.map((item, index) => (
                                      <div
                                        key={item.id}
                                        className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                        onClick={() =>
                                          handleCompanyNameSelect(item)
                                        }
                                      >
                                        {item.companyname}
                                      </div>
                                    ))
                                  : uniqueCompanynames.map((item) => (
                                      <div
                                        key={item.id}
                                        className="px-4 py-1 cursor-pointer Z-10 hover:bg-white hover:w-full"
                                        onClick={() =>
                                          handleCompanyNameSelect(item)
                                        }
                                      >
                                        {item.companyname}
                                      </div>
                                    ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        ref={assignDropdownRef}
                        className="relative flex items-center justify-end py-3 cursor-pointer"
                      >
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Model Assign to :
                        </label>
                        <div
                          className="flex items-start mb-2 pb-1 text-black border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                        >
                          {/* ✅ SOLUTION: Use access.length for the count */}
                          {access.length} selected of {user?.length}
                        </div>{" "}
                        <div
                          onClick={toggleDropdownfilter}
                          className="absolute bottom-6 right-1 flex justify-center items-center p-[0.2px] bg-[#ffffff] shadow-black shadow-sm rounded-md"
                        >
                          <RiArrowDownSFill className="text-xl" />
                        </div>
                        {isDropdownOpenfilter && (
                          <div
                            style={{
                              border: "1px solid #0000000a",
                              zIndex: "100",
                            }}
                            className="lg:text-[10px] lg:w-fit xl:text-[15px] absolute top-9 left-36 bg-white shadow-xl rounded-md "
                          >
                            <ul className="overflow-y-auto h-[140px] modelscroll py-2">
                              <li className="flex items-center justify-center ">
                                <div className="w-full flex items-center justify-start pl-2 my-1 mx-1 rounded-[5px] text-black bg-white shadow-md border border-black-300 border-opacity-60">
                                  <IoIosSearch className="text-xl text-[#D2D2D2]" />
                                  <input
                                    type="text"
                                    placeholder="Search..."
                                    // ✅ SOLUTION: Bind value to make it a controlled component
                                    value={searchUserTerm}
                                    onChange={handleUserSearch}
                                    className="w-[100px] placeholder-[#D2D2D2] bg-transparent outline-none border-none px-2 text-md"
                                  />
                                </div>
                              </li>
                              <li className="flex items-center justify-between px-2 py-1 text-black border-t cursor-pointer">
                                <span className="text-[12px]">All</span>
                                <div className="flex items-center justify-end">
                                  <label className="inline-flex items-center">
                                    <div
                                      className={`w-4 h-4 bg-white shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${
                                        selectAllChecked ? "bg-red-500" : ""
                                      }`}
                                    >
                                      {selectAllChecked && (
                                        <div className="w-2 h-2 bg-red-500"></div>
                                      )}
                                    </div>
                                    <input
                                      className="hidden"
                                      type="checkbox"
                                      checked={selectAllChecked}
                                      onChange={handleSelectAllChanged}
                                    />
                                  </label>
                                </div>
                              </li>
                              
                              {/* ✅ SOLUTION: Consolidated mapping logic */}
                              {(searchUserTerm.length > 0 ? filterUserData : user).map((item) => (
                                <div
                                    key={item._id}
                                    className="flex items-center justify-between px-2 py-1 text-black border-t border-[#A8A8A8] cursor-pointer"
                                >
                                    <span className="text-[12px]">{item.email}</span>
                                    <div className="flex items-center">
                                        <label className="inline-flex items-center">
                                            <div
                                                className={`w-4 h-4 bg-white shadow-md border-red-500 rounded-sm flex items-center justify-center ml-2 ${
                                                    access.includes(item.email) ? "bg-red-500" : ""
                                                }`}
                                            >
                                                {access.includes(item.email) && (
                                                    <div className="w-2 h-2 bg-red-500"></div>
                                                )}
                                            </div>
                                            <input
                                                className="hidden"
                                                type="checkbox"
                                                checked={access.includes(item.email)}
                                                onChange={() => handleCheckboxChanged(item.email)}
                                            />
                                        </label>
                                    </div>
                                </div>
                               ))}

                            </ul>
                            <button
                              type="button"
                              className="flex justify-center w-full bg-white item-center rouded-md py-1"
                              onClick={toggleDropdownfilter}
                            >
                              Apply
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="flex items-center text-gray-500 justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="platformSelect"
                          className="flex items-end px-3 font-semibold text-black"
                        >
                          Platform:
                          <span className="ml-1 text-red-500">*</span>
                        </label>
                        <div
                          className="flex pb-1 border-b border-gray-500 outline-none"
                          style={{ width: "163px" }}
                        >
                          <select
                            id="platformSelect"
                            className="w-full bg-transparent outline-none text-center"
                            value={platform}
                            onChange={(e) => setPlatform(e.target.value)}
                            required
                          >
                            <option value="">Select Platform</option>
                            <option value="Android">Android</option>
                            <option value="iOS">iOS</option>
                          </select>
                        </div>
                      </div>
                      <div className="flex items-center justify-end py-3 cursor-pointer">
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3 font-semibold"
                        >
                          Uploaded By :
                        </label>
                        <input
                          disabled
                          value={userName}
                          type="text"
                          id="yourInput"
                          className="flex items-start mb-2 border-b border-gray-500 outline-none"
                          style={{ width: "163px", textAlign: "center" }}
                          placeholder="Super Admin (Auto)"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center p-1 mt-1 space-x-12 button-container pt-5">
                    <button
                      onClick={handleClosePopup}
                      type="button"
                      className="flex-shrink-0 w-16 text-black bg-white shadow-md loginbtn rounded-sm"
                      style={{
                        background: "(.white.opacity(0.57))",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={`loginbtn text w-16 flex-shrink-0 rounded-sm ${
                        thumbnailPerc < 100 || modelPerc < 100
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-custom-gradient"
                      }`}
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                      disabled={thumbnailPerc < 100 || modelPerc < 100}
                    >
                      Create
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </>
      <div className="flex lg:px-4">
        <div className="w-full flex bg-white shadow-md backdrop-blur-[5.7px]">
          <div className="w-full flex justify-between items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0 px-4">
            <div className="w-1/3 flex justify-start">
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"...."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                className="flex justify-start items-center gap-2 text-blue-500"
              />
            </div>
            <div className="w-1/3 text-center text-gray-700">
              <p>
                Showing {filteredCount} {modelType} model(s)
                {platformFilter !== "All" ? ` for ${platformFilter}` : ""}
              </p>
            </div>
            <div className="w-1/3"></div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
}